import React, { createContext, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

// Create context
const AuthContext = createContext();

/**
 * AuthProvider component
 * Provides authentication state and token to components
 */
export const AuthProvider = ({ children }) => {
  const { isAuthenticated, user, token } = useSelector((state) => state.auth);
  const [authState, setAuthState] = useState({
    isAuthenticated,
    user,
    token
  });

  // Update auth state when Redux state changes
  useEffect(() => {
    setAuthState({
      isAuthenticated,
      user,
      token
    });
  }, [isAuthenticated, user, token]);

  return (
    <AuthContext.Provider value={authState}>
      {children}
    </AuthContext.Provider>
  );
};

/**
 * Custom hook to use auth context
 */
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
